import { StyledDialog } from "../../../components/StyledComponents/Dialog/Dialog.js";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";
import { Box, DialogContent } from "@mui/material";
import {
  BodyMedium,
  H6HeadlineSmall,
  H7TitleLarge,
  H9TitleSmall,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth0 } from "@auth0/auth0-react";
import useMinerPageContext from "../../context/useMinerPageContext.js";
import { format, parseISO } from "date-fns";
import { isEmpty } from "lodash";

const FansHeader = ({ setOpen }) => {
  const { colors } = useTheme();
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      flexGrow={1}
      padding={"1.5rem 0"}
    >
      <Box display={"flex"} flexDirection={"column"} gap={2}>
        <H6HeadlineSmall>{"Fan Stats"}</H6HeadlineSmall>

        <BodyMedium>Use this window to observe fan stats.</BodyMedium>
      </Box>

      <StyledIconButton 
        colors={colors}
        onClick={() => {
          setOpen(false);
        }}
      >
        <CloseIcon />
      </StyledIconButton>
    </Box>
  );
};

const FansForm = ({ setOpen, FansData }) => {
  const { colors } = useTheme();
  if (!Array.isArray(FansData)) return <></>;
  return (
    <>
      <FansHeader setOpen={setOpen} />
      <Box display={"flex"} flexGrow={1}>
        <Box
          display={"flex"}
          flexDirection={"column"}
          flexGrow={1}
          gap={2}
          padding={"0 1.5rem 1.5rem 1.5rem"}
        >
          {Array.isArray(FansData) && FansData.length !== 0 ? (
            FansData.map((fanData, index) => (
              <Box
                key={index}
                display={"grid"}
                gridTemplateColumns={"1fr"}
                gap={"0.75rem"}
                sx={{
                  padding: "1.25rem 2rem 2rem 2rem",
                  borderRadius: "1.5rem",
                  backgroundColor: colors.background.accent,
                }}
              >
                {!isEmpty(fanData) && Object.entries(fanData).length > 0 ? (
                  Object.entries(fanData).map(([key, value], index) => (
                    <Box
                      display={"grid"}
                      gridTemplateColumns={"1fr 3fr"}
                      key={key + index}
                    >
                      <H9TitleSmall>{key} :</H9TitleSmall>
                      <BodyMedium>{value}</BodyMedium>
                    </Box>
                  ))
                ) : (
                  <BodyMedium>No data available</BodyMedium>
                )}
              </Box>
            ))
          ) : (
            <Box
              display={"flex"}
              justifyContent={"center"}
              sx={{
                padding: "2rem",
                borderRadius: "1.5rem",
                backgroundColor: colors.background.accent,
              }}
            >
              <BodyMedium>No data available</BodyMedium>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

const FansDialog = ({ open, setOpen }) => {
  const { fansData } = useMinerPageContext();
  const { colors } = useTheme();
  const FansData = fansData || [];
  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      open={open}
      hideBackdrop
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          setOpen(false);
        }
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <FansForm setOpen={setOpen} FansData={FansData} />
      </DialogContent>
    </StyledDialog>
  );
};

export default FansDialog;
